import { Button, useMantineTheme } from '@mantine/core';
import { Icon } from '@/components';
import { type Icon as FeatherIcon } from 'react-feather';
import { Link, type To } from 'react-router-dom';
import classes from './MenuItem.module.css';

type MenuItemProps = {
  label: string;
  Component: FeatherIcon;
} & ({ to: To; onClick?: never } | { onClick: () => void; to?: never });

export const MenuItem = ({ Component, to, label, onClick }: MenuItemProps) => {
  const theme = useMantineTheme();

  const buttonProps = {
    size: 'lg',
    className: classes.button,
    variant: 'white',
    onClick,
    w: '100%',
    px: 'sm',
    leftSection: (
      <Icon Component={Component} color={theme.colors.tealBrand[7]} size={24} />
    ),
  } as const;

  if (to) {
    return (
      <Button component={Link} to={to} {...buttonProps}>
        <span className={classes.label}>{label}</span>
      </Button>
    );
  }

  return (
    <Button {...buttonProps}>
      <span className={classes.label}>{label}</span>
    </Button>
  );
};
